export default "__VITE_ASSET__CYvrizcv__"